
import { defineComponent, PropType, reactive } from 'vue'

// components
import Checkbox from '@/common/components/UI/Checkbox/index.vue'

// types
import { RPPOrderT } from '@/core/types/rpp.types'

export default defineComponent({
    components: {
        checkbox: Checkbox,
    },
    props: {
        item: {
            type: Object as PropType<RPPOrderT>,
            required: true,
        },
    },
    emits: ['select'],
    setup(props, { emit }) {
        const state = reactive({
            is_order_selected: false,
        })

        const emitSelectOrder = () => {
            emit('select', props.item.id)
        }

        return { state, emitSelectOrder }
    },
})
